import { PagedResult, Result } from "../models/Result";
import { httpService } from "./HttpService";
import { SftpTransaction } from "../models/Transactions";
import { SearchRequestBaseModel } from "../models/SearchRequestModel";

class SFTPService {
   
    baseApiUrl = process.env.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_FILE_API_BASE_URL;
    ListFiles = async (searchRequest: SearchRequestBaseModel) : Promise<PagedResult<SftpTransaction[]>> => {
        return await httpService.getPage<SftpTransaction[]>("/Sftp/search", searchRequest);
    };

    GetFileContent = async (fileName : string) : Promise<Result<string>> => {
        return await httpService.get<string>(`/api/v1/Sftp/${encodeURIComponent(fileName)}`, { baseURL: this.baseApiUrl });
    };
}

const sftpService = new SFTPService();

export { sftpService };